console.info('%c🔥CK Started!', 'color: red; font-size: 2rem;')
